import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { usePaymentTrend } from '../../hooks/usePayments';
import { formatNumber } from '@shared/utils/format';

export default function PaymentTrendChart({ townId }: { townId?: number }) {
    const { data } = usePaymentTrend(12, townId);

    return (
        <div className="bg-white rounded shadow-sm border border-[#E6E9ED] p-4 mb-5">
            <h3 className="text-xs font-bold text-[#2A3F54] uppercase tracking-wider mb-3">월별 결제 추이 (최근 12개월)</h3>
            <ResponsiveContainer width="100%" height={260}>
                <LineChart data={data ?? []} margin={{ top: 5, right: 20, bottom: 5, left: 10 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#E6E9ED" />
                    <XAxis dataKey="ym" tick={{ fontSize: 11, fill: '#ADB5BD' }} />
                    <YAxis tick={{ fontSize: 11, fill: '#ADB5BD' }} tickFormatter={(v) => `${(v / 10000).toFixed(0)}만`} />
                    <Tooltip formatter={(v: number) => `${formatNumber(v)}원`} />
                    <Line type="monotone" dataKey="totalAmount" name="전체" stroke="#1ABB9C" strokeWidth={2} dot={{ r: 3 }} />
                    {townId && <Line type="monotone" dataKey="townAmount" name="선택 단지" stroke="#3498DB" strokeWidth={2} dot={{ r: 3 }} />}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
